export const NODE_ENV = import.meta.env.VITE_NODE_ENV;

export const API_URL =
  NODE_ENV === 'development' ? import.meta.env.VITE_DEV_API : import.meta.env.VITE_PROD_API;
